import React, { useEffect, useState } from 'react';
import { OtherSettingsType } from 'utils/types';
import Shop from 'assets/icons/shop.svg';
import ScheduleOrder from 'assets/icons/schedule_order.svg';
import Vat from 'assets/icons/vat.svg';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { Breadcrumbs, Switch, ToastMessage } from '@cokitchen/cokitchen-components';
import useDashboardContext from 'contexts/dashboard.context';
type OtherSettingsMethod = {
  name: string;
  icon: string;
  key: keyof OtherSettingsType;
};

const otherSettingsArray: OtherSettingsMethod[] = [
  {
    name: 'FC Shop',
    icon: Shop,
    key: 'show_shop'
  },
  {
    name: 'Schedule Order',
    icon: ScheduleOrder,
    key: 'show_schedule'
  },
  {
    name: 'Value Added Tax (VAT)',
    icon: Vat,
    key: 'vat_enabled'
  }
];
const OtherSettings = () => {
  const { activeCokitchen } = useDashboardContext();
  const [otherSettingsObject, setOtherSettingsObject] = useState<OtherSettingsType>(
    {} as OtherSettingsType
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (activeCokitchen.id) getSettings();
  }, [activeCokitchen.id]);

  const getSettings = async () => {
    try {
      const res = await apiService.get(`marketing/cokitchen/settings/${activeCokitchen?.id}`, {
        isInternal: true
      });
      const { data } = res.data;
      setOtherSettingsObject({
        show_shop: data?.show_shop,
        show_schedule: data?.show_schedule,
        vat_enabled: data?.vat_enabled
      });
    } catch (error) {
      console.log(error);
    }
  };

  const updateSetting = async (key: keyof OtherSettingsType) => {
    try {
      setLoading(true);
      const updatedValue = {
        ...otherSettingsObject,
        [key]: !otherSettingsObject[key]
      };

      await apiService.put(`marketing/cokitchen/settings`, {
        data: {
          ...updatedValue,
          cokitchen_id: activeCokitchen.id
        }
      });
      setOtherSettingsObject(updatedValue);
      toast(<ToastMessage message='Settings updated successfully' type='success' />);
    } catch (error) {
      toast(<ToastMessage message='Error updating payment settings' type='error' />);
      getSettings();
    } finally {
      setLoading(false);
    }
  };
  const breadCrumbs = [
    { name: 'Settings', path: `/settings` },
    {
      name: 'Others',
      path: ''
    }
  ];

  return (
    <div>
      <Breadcrumbs breadcrumbs={breadCrumbs} />
      <div className='w-full flex justify-center items-center mt-8'>
        <div className='w-full max-w-[514px] shadow py-6 px-[30px]'>
          <h6 className='text-[24px] font-semibold'>Others</h6>
          <p className='text-gray-5 font-medium text-sm mb-8'>
            Manage VAT, schedule order and Shop on the FC App
          </p>
          {otherSettingsArray.map((setting) => (
            <div
              className='flex justify-between w-full rounded-md border-[0.8px] border-[#EAEBEB] h-[68px] p-5 mb-4'
              key={setting.name}>
              <div className='flex gap-4'>
                <img src={setting.icon} alt='setting icon' />
                <p className='font-medium'>{setting.name}</p>
              </div>
              <Switch
                active={otherSettingsObject[setting.key] ?? false}
                onChange={() => {
                  setOtherSettingsObject((prev) => ({
                    ...prev,
                    [setting.key]: !prev[setting.key]
                  }));
                  updateSetting(setting.key);
                }}
                disabled={loading}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OtherSettings;
